import { ref, computed, watch } from "vue";

const isDark = ref(localStorage.getItem("darkMode") === "true");
const toolbarIconColor = computed(() =>
  isDark.value ? "grey lighten-3" : "grey darken-3"
);
const toolbarIconColorClass = computed(() =>
  isDark.value ? "grey--text text--lighten-3" : "grey--text text--darken-3"
);

export default function useDarkMode() {
  const toggleDarkMode = () => {
    isDark.value = !isDark.value;
  };

  const setDarkMode = (value) => {
    isDark.value = value;
  };

  watch(
    isDark,
    (newValue) => {
      localStorage.setItem("darkMode", newValue.toString());
    },
    { immediate: true }
  );

  return {
    isDark: computed(() => isDark.value),
    toggleDarkMode,
    setDarkMode,
    toolbarIconColor,
    toolbarIconColorClass,
  };
}
